import { CSSObject } from '@emotion/react'
import { sharedColors } from '../../sharedDisplays/sharedStyles/colors'

type DisplayProps = {
  [key: string]: {
    width: string
    height: string
  }
}

const assetStyles: DisplayProps = {
  mobileStream: {
    height: '211px',
    width: '375px',
  },
  desktopStream: {
    height: '377px',
    width: '600px',
  },
}

export const textColors = {
  darkerGray: '#14171a',
  darkGray: '#3f4347',
  lightGray: '#657786',
  medGray: '#868f98',
}

const getAssetStyles = (display: string): CSSObject => ({
  ...assetStyles[display],
  img: {
    ...assetStyles[display],
  },
})

const getHeaderWrapperStyles = (isMobile: boolean): CSSObject => ({
  backgroundColor: 'white',
  border: sharedColors.momentBorder,
  padding: isMobile ? '11px 11px 10px' : '8px 9px 10px',
})

const accountWrapper: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  padding: '0 5px',
}

const getAccountStyles = (isMobile: boolean): CSSObject => ({
  display: 'flex',
  flexDirection: isMobile ? 'column' : 'row',
  marginLeft: isMobile ? '10px' : '5px',
})

const getScheduledTimeStyles = (isMobile: boolean): CSSObject => ({
  padding: isMobile ? '7px 5px 0' : '9px 5px 0',
})

const accountName: CSSObject = {
  fontWeight: 600,
}

const getAccountUsername = (isMobile: boolean): CSSObject => ({
  display: 'flex',
  marginLeft: isMobile ? 0 : '8px',
})

const title: CSSObject = {
  color: textColors.darkGray,
  fontSize: 24,
  fontWeight: 600,
  marginTop: '7px',
}

const description: CSSObject = {
  color: textColors.darkGray,
  fontSize: 16,
}

const styles = {
  accountName,
  accountWrapper,
  description,
  getAccountStyles,
  getAccountUsername,
  getAssetStyles,
  getHeaderWrapperStyles,
  getScheduledTimeStyles,
  title,
}

export { styles }
